import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { CoreModule } from '@ridango/core';

import { RideBookingsActions, RideBookingsEpics, RideBookingsFacade } from './+state';
import { RideBookingsService } from './ride-bookings.service';

@NgModule({
    declarations: [],
    imports: [CoreModule, CommonModule],
    providers: [RideBookingsActions, RideBookingsFacade, RideBookingsEpics, RideBookingsService],
})
export class RideBookingsModule {
}
